import { ExternalLink } from "@aircall/react-icons";
import { PropsWithChildren } from "react";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section/Section";

function GridEntry({ label, children }: PropsWithChildren<{ label: string }>) {
  return (
    <>
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      <div>{children}</div>
    </>
  );
}

export function PlaygroundSectionTiming() {
  return (
    <Section data-test="timing-section">
      <SectionHeader>
        <SectionTitle>Timing</SectionTitle>
      </SectionHeader>
      <div className="flex flex-col gap-2">
        <div
          className="grid items-center gap-2"
          style={{ gridTemplateColumns: "auto 1fr" }}
        >
          <GridEntry label="Start time">
            <div className="flex items-center gap-1">
              <span>January 15, 2024 at 10:00 AM</span>
              <span className="text-muted-foreground">(yesterday)</span>
            </div>
          </GridEntry>
          <GridEntry label="Waited time">
            <span>1m 0s</span>
          </GridEntry>
          <GridEntry label="In-call time">
            <span>2m 0s</span>
          </GridEntry>
          <GridEntry label="Total call time">
            <span>3m 0s</span>
          </GridEntry>
        </div>
        <a
          data-test="open-call-timeline-anchor"
          className="inline-flex items-center gap-1 self-start p-0 text-xs font-normal text-primary"
          target="_blank"
          href="#"
          rel="noreferrer"
        >
          Open Call Timeline
          <ExternalLink className="size-[18px]" />
        </a>
      </div>
    </Section>
  );
}
